module.exports = __webpack_public_path__ + "static/media/glass-martini.aeb42c48.svg";